import { Col, Row } from "antd";
import { connect } from "react-redux";
import { COL_SPAN, STRING_DATE } from "../../../const/constant";
import dayjs from "dayjs";
import formatAmount from "../../../utility/formatAmount";

function RequestInfoCol(props) {
  const { device, currDuty, extraCol, l_paid } = props;
  return (
    <Row gutter={[0, 16]}>
      <Col span={COL_SPAN[device.size][0]}>Dept:</Col>{" "}
      <Col span={COL_SPAN[device.size][1]}>{currDuty.DEPT_ABBR}</Col>
      <Col span={COL_SPAN[device.size][0]}>Post Title:</Col>{" "}
      <Col span={COL_SPAN[device.size][1]}>{currDuty.POST_TITLE}</Col>
      <Col span={COL_SPAN[device.size][0]}>Duty Period:</Col>
      <Col span={COL_SPAN[device.size][1]}>
        {dayjs(currDuty.START_DATE).format(STRING_DATE)} to{" "}
        {dayjs(currDuty.END_DATE).format(STRING_DATE)}
      </Col>
      <Col span={COL_SPAN[device.size][0]}></Col>{" "}
      <Col span={COL_SPAN[device.size][1]}></Col>
      <Col span={COL_SPAN[device.size][0]}>Prog/Proj Code:</Col>{" "}
      <Col span={COL_SPAN[device.size][1]}>{currDuty.PROG_PROJ_CODE}</Col>
      <Col span={COL_SPAN[device.size][0]}>Prog/Proj Title:</Col>{" "}
      <Col span={COL_SPAN[device.size][1]}>{currDuty.PROG_PROJ_TITLE}</Col>
      {extraCol}
      {currDuty.RATE_TYPE === "H" ? (
        <>
          <Col span={COL_SPAN[device.size][0]}>Hourly Rate:</Col>{" "}
          <Col span={COL_SPAN[device.size][1]}>
            {formatAmount(currDuty.HR_RATE)}
          </Col>
          <Col span={COL_SPAN[device.size][0]}>Requested Hours:</Col>{" "}
          <Col span={COL_SPAN[device.size][1]}>
            {currDuty.HR_PAID}
          </Col>
        </>
      ) : currDuty.RATE_TYPE === "M" ? (
        <>
          {/* <Col span={COL_SPAN[device.size][0]}>MONTHLY Rate:</Col>{" "}
          <Col span={COL_SPAN[device.size][1]}>
            {formatAmount(currDuty.MONTHLY_RATE)}
          </Col> */}
        </>
      ) : currDuty.RATE_TYPE === "L" ? (
        <>
          <Col span={COL_SPAN[device.size][0]}>Remaining:</Col>{" "}
          <Col span={COL_SPAN[device.size][1]}>
            {formatAmount(Math.max(currDuty.LUMP_SUM - l_paid, 0))}
          </Col>
        </>
      ) : (
        <></>
      )}
      <Col span={COL_SPAN[device.size][0]}>Duty:</Col>{" "}
      <Col span={COL_SPAN[device.size][1]}>{currDuty.DT_DESC}</Col>
    </Row>
  );
}

const mapStateToProps = (state) => {
  return {
    currDuty: state.data.currDuty,
    device: state.session.device,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RequestInfoCol);
